
import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterLink, Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { ShamMail01BulkIcon } from 'sham-components/icons';
import { TranslateModule } from '@ngx-translate/core';
import { AuthApi } from '@/app/services/auth-api';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [
    RouterLink,
    CommonModule,
    FormsModule,
    ShamMail01BulkIcon,
    TranslateModule
  ],
  templateUrl: './forgot-password.html',
  styleUrl: './forgot-password.css',
})
export class ForgotPasswordPage {
  private router = inject(Router);
  private authApi = inject(AuthApi);

  email: string = '';
  isLoading = false;
  errorMessage = '';

  onSubmit() {
    if (!this.email) return;

    this.isLoading = true;
    this.errorMessage = '';

    this.authApi.forgotPassword(this.email).subscribe({
      next: () => {
        this.isLoading = false;
        this.authApi.setAuthFlowData({
  email: this.email,
  flow: 'forgot-password'
});

this.router.navigate(['/auth/email-verification']);
      },
      error: (err) => {
        this.isLoading = false;
        this.errorMessage = err.error?.message || 'حدث خطأ، حاول مجدداً';
      }
    });
  }
}
